import wixWindow from 'wix-window';
import wixLocation from 'wix-location';
import wixData from 'wix-data';

export function button4_click(event) {
	if ($w('#firstName').value === 'סטטיק') {
			$w('#box8').show();
			}
	else if ($w('#firstName').value === 'static') {
			$w('#box8').show();
			}	
	else if ($w('#firstName').value === 'Static') {
			$w('#box8').show();
			}	
	else if ($w('#firstName').value === 'לירז') {
			$w('#box8').show();
			}	
	else if ($w('#firstName').value === 'לירז רוסו') {
			$w('#box8').show();
			}	
	else {
		wixWindow.openLightbox("no");
	}		
}

// HINTS BUTTONS
/*export function button1_click(event) {
	
	$w('#text32').show();
	$w('#button1').hide();
	$w('#button2').show();
}
*/
$w.onReady(async function () {
 const findResult = await findHints();
 //console.log("findResult")
 console.log(findResult.hintscount)
 let number = findResult.hintscount;
    $w("#button1").onClick(async () => {
        number += 1;
		$w('#text32').show();
		$w('#button1').hide();
		$w('#button2').show();
 const updateResult = await UpdateHintsDatabase(findResult._id, number)
    })

	$w("#button2").onClick(async () => {
    	number += 1;
		$w('#text33').show();
		$w('#text32').hide();
		$w('#button2').hide();
		$w('#button3').show();
	
 const updateResult = await UpdateHintsDatabase(findResult._id, number)
    })

	$w("#button3").onClick(async () => {
       	number += 1;
		$w('#button2').hide();
		$w('#button3').hide();
		$w('#text33').hide();
		$w('#text34').show();
 const updateResult = await UpdateHintsDatabase(findResult._id, number)
    })
});

function findHints() {
 return wixData.query("hints")
    .find()
    .then((res) => {
 return (res.items[0])
    })
}

function UpdateHintsDatabase(id, number) {
	//console.log(id)
	//console.log("number:")
	//console.log(number)
	wixData.get("hints", id)
        .then((res) => {
			res.hintscount = number
            wixData.update("hints", res)
        })
}
/*export function button2_click(event) {
	$w('#text33').show();
	$w('#text32').hide();
	$w('#button2').hide();
	$w('#button3').show();
}

export function button3_click(event) {
	$w('#button2').hide();
	$w('#button3').hide();
	$w('#text33').hide();
	$w('#text34').show();
}*/